import React from 'react';
// import { Link } from 'react-router-dom';

function SocialMediaLinks() {
  return (
    <div className="navbar-end">
      <ul className="_footer_safe_tour_list" style={{ display: 'flex' }}>
        {[{
          name: 'facebook',
          link: 'https://facebook.com'
        }, {
          name: 'instagram',
          link: 'https://instagram.com'
        }, {
          name: 'twitter',
          link: 'https://twitter.com'
        }, {
          name: 'linkedin',
          link: 'https://linkedin.com'
        }, {
          name: 'youtube',
          link: 'https://youtube.com'
        }].map(({ name, link }) => {
          return (
            <li className="_footer_safe_tour_list_item mr-5" key={name}>
              <a className="_footer_safe_tour_list_link" href={link} target="_blank" title={name} rel="noreferrer">
                <i className={`fab fa-${name}`}></i>
              </a>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default SocialMediaLinks;
